const headerIndex = [
  { path: "/about", name: "about" },
  { path: "/services", name: "services" },
]

export default headerIndex
